export default function WorkingHoursBar() {
  return (
    <div className="bg-gray-950 py-4 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-1.5 bg-brand-orange rounded-full"></span>
            <span className="text-gray-400 font-medium uppercase tracking-widest text-xs">Çalışma Saatleri</span>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-center">
            <div className="flex items-center gap-2">
              <span className="w-4 h-4 flex items-center justify-center text-gray-500">
                <i className="ri-building-2-line"></i>
              </span>
              <span className="text-gray-400">Hafta İçi: <strong className="text-white font-semibold">08:00 – 18:00</strong></span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-gray-700"></div>
            <div className="flex items-center gap-2">
              <span className="w-4 h-4 flex items-center justify-center text-gray-500">
                <i className="ri-calendar-2-line"></i>
              </span>
              <span className="text-gray-400">Cumartesi: <strong className="text-white font-semibold">08:00 – 13:00</strong></span>
            </div>
          </div>

          <div className="flex items-center gap-2 border border-brand-orange/40 text-brand-orange px-4 py-1.5 rounded-full">
            <span className="w-2 h-2 bg-brand-orange rounded-full animate-pulse"></span>
            <span className="font-semibold text-xs whitespace-nowrap">7/24 WhatsApp Aktif</span>
          </div>
        </div>
      </div>
    </div>
  );
}
